import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["bsSponsored", "bsPopover"];

  connect() {
    const src = "//m.servedby-buysellads.com/monetization.js"
    loadScript(src, () => {
      if (this.bsPopoverTargets.length > 0) {
        this.loadPopOverAds();
      }

      if (this.bsSponsoredTargets.length > 0) {
        this.loadSponsoredExchangeAds();
      }
    }, true);
  }

  loadPopOverAds() {
    if (typeof _bsa !== 'undefined' && _bsa) {
      _bsa.init('custom', 'CE7DCKQW', 'placement:coingecko-button',
        {
          target: '#buysell-button-01',
          template:
            `
              <div class="p-2 px-2">
                <div>
                  <a target="_blank" rel="noopener nofollow" href="##statlink##">
                    <img alt="##company##" src="##logo##" style="width: 20px; height: 20px;">##company##</img>
                    <div class="text-muted mt-1" style="line-height: 1;">
                      <small>##description##</small>
                    </div>
                  </a>
                </div>
              </div>
            `
        }
      );

      _bsa.init('custom', 'CE7DCKQM', 'placement:coingecko-button',
        {
          target: '#buysell-button-02',
          template:
            `
              <div class="p-2 px-2">
                <div>
                  <a target="_blank" rel="noopener nofollow" href="##statlink##">
                    <img alt="##company##" src="##logo##" style="width: 20px; height: 20px;">##company##</img>
                    <div class="text-muted mt-1" style="line-height: 1;">
                      <small>##description##</small>
                    </div>
                  </a>
                </div>
              </div>
            `
        }
      );      
    }
  }

  loadSponsoredExchangeAds() {
    if (typeof _bsa !== 'undefined' && _bsa) {
      _bsa.init('custom', 'CE7DCKQU', 'placement:coingecko-exchange-01',
        {
          target: '#sponsored-exchange-01',
          template:
            `
              <span class="table-number" style="margin-right: 31px;">*</span>
              <span>
                <span>
                  <img width="20" height="20" class="mr-1" src="##logo##">
                  <a rel="nofollow" href="##statlink##">##company##</a>
                </span>
                <span class="badge badge-warning">
                  <span class="translation_missing" title="##description##">Sponsored</span>
                </span>
              </span>
            `
        }
      );
    }
  }
}
